import { Button } from 'client/widgets/ui';
import { UiModal } from 'components';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

const StyledUiModal = styled(UiModal)`
  .ui-modal-header {
    justify-content: center;
  }
`;

const Wrap = styled.div`
  text-align: center;
  .tip {
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    text-align: center;
    color: #c3c3c3;
    background: #454d56;
    width: 234px;
    height: 20px;
    border-radius: 10px;
    margin: 0 auto;
  }

  .avatar {
    padding: 16px 0 8px;
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      vertical-align: top;
    }
  }

  .nickname {
    .text-overflow {
      max-width: 8em;
    }
  }

  .content {
    background: #454d56;
    border-radius: 4px;
    padding: 12px 18px;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    margin: 16px 0 30px;
  }

  .action {
    ._btn {
      width: 150px;
    }
  }
`;

const PopupEnter = observer((props) => {
  const { data, onClose } = props;

  return (
    <StyledUiModal
      title="心愿发起用户已进入直播间"
      closeEnable={false}
      isShowFooter={false}
      width={400}
    >
      <Wrap>
        <div className="tip">请开始按照约定达成用户心愿</div>
        <div className="avatar">
          <img src={data.pic} alt="" />
        </div>
        <div className="nickname">
          <span className="text-overflow">{data.nickname}</span>
        </div>

        <div className="content">{data.content}</div>
        <div className="action">
          <Button round size="lg" onClick={onClose}>
            知道了
          </Button>
        </div>
      </Wrap>
    </StyledUiModal>
  );
});

export default PopupEnter;
